import React, {useState, useEffect} from "react";
import {useParams, useNavigate} from 'react-router-dom';
import DatePicker from 'react-date-picker'; // https://github.com/wojtekmaj/react-date-picker
import TimePicker from 'react-time-picker'; // https://github.com/wojtekmaj/react-time-picker
import {
	getEvent,
	saveEvent,
	getLevelProjects,
	handleEventProjectChange,
	saveProject,
	formatDate,
	cloneAltProjects,
	formatTime
} from "./apiService";

const EditEvent = (props) => {
	const [date, setDate] = useState(new Date());
	const [time, setTime] = useState(new Date());
	const [comments, setComments] = useState('');
	const [error, setError] = useState(null);
	const [isLoaded, setIsLoaded] = useState(false);
	const [event, setEvent] = useState(null);
	const [projects, setProjects] = useState([]);
	const [addingProject, setAddingProject] = useState(null);
	const [addProjectOkButtonDisabled, setAddProjectOkButtonDisabled] = useState(true);
	const {eventIdParam} = useParams();
	const navigate = useNavigate();

	useEffect(() => {
		console.log('EditEvent.useEffect', eventIdParam);
		let eventId = eventIdParam;

		let getAltProjects = (sourceProjects) => {
			let projects = [];

			let getAltProjectsInner = (altProjectIndex) => {
				projects[altProjectIndex] = [];
				if(altProjectIndex >= sourceProjects.length) {
					// done
					console.log('projects', projects);
					return getLevelProjects([]).then(
						levelProjects => {
							projects[altProjectIndex] = levelProjects;
							return new Promise((resolve, reject) => {
								resolve(projects);
							});
						},
						error => {
							console.error('failed to get level projects for last alt', error);
							return new Promise((resolve, reject) => {
								reject(error);
							});
						}
					);
				};
				return getLevelProjects(sourceProjects[altProjectIndex]).then(
					levelProjects => {
						projects[altProjectIndex] = levelProjects;
						return getAltProjectsInner(altProjectIndex + 1);
					},
					error => {
						console.error(`failed to get level projects for alt ${altProjectIndex}`, error);
						return new Promise((resolve, reject) => {
							reject(error);
						});
					}
				);
			};
			return getAltProjectsInner(0);
		};

		if(eventId == null) {
			setIsLoaded(true);
			setEvent(null);
			let date = new Date();
			setDate(date);
			setTime(date);
			getAltProjects([]).then(
				projects => {
					setProjects(projects);
				},
				error => {
					setError(error);
				});
		}
		else getEvent(eventId).then(
			data => {
				console.log('EditEvent.useEffect getEvent data', data);
				if(data.status === 401) {
					navigate('/login', {replace: true});
					return;
				}
				if(data.status !== 200) {
					setIsLoaded(true);
					setError(data);
					return;
				}
				setIsLoaded(true);
				setEvent(data.result);
				let datetime = new Date(data.result.datetime);
				setDate(datetime);
				setTime(datetime);
				setComments(data.result.comments == null ? '' : data.result.comments);
				getAltProjects(data.result.projects).then(
					projects => {
						setProjects(projects);
					},
					error => {
						setError(error);
						console.error('error object', error);
					});
			},
			error => {
				setIsLoaded(true);
				setError(error);
				console.error('error object', error);
			}
		);
	}, [eventIdParam, navigate]);

	if(error) {
		return <div>Error: {error.message}</div>;
	}

	if(!isLoaded) {
		return <div>Loading...</div>;
	}

	console.log('EditEvent render', event, projects);

	const handleCommentChange = e => {
		console.log('EditEvent.handleCommentChange', e);
		const name = e.target.name;
		const value = e.target.value;
		if(name !== 'comments') {
			console.error('EditEvent.handleCommentChange unexpected target name: ' + name);
			return;
		}
		setComments(value);
	};

	const handleCancel = e => {
		navigate(`/events/${formatDate(date)}`);	
	};

	const handleSubmit = e => {
		console.log('EditEvent.handleSubmit', e);
		e.preventDefault();
		let eventId = event ? event.id : null;
		let submitEvent = {date: date, time: time};
		if(eventId) {
			submitEvent.id = eventId;
		}
		submitEvent.projects = [];
		for(let altProject of projects) {
			let  lastProjectId = null;
			for(let levelProject of altProject) {
				if(levelProject.id) {
					lastProjectId = levelProject.id;
				}
			}
			if(lastProjectId != null) {
				submitEvent.projects.push(lastProjectId);
			}
		}
		console.log('EditEvent.handleSubmit submitEvent', submitEvent);
		saveEvent(submitEvent).then(
			data => {
				console.log('saveEvents data', data);
				if(data.status !== 200) {
					alert(data.message);
					return;
				}
				navigate(`/events/${formatDate(date)}`);	
			},
			error => {
				alert(error.message);
				console.error('error object', error);
			}
		);
	};

	const handleAddProject = e => {
		console.log('handleAddProject', e);
		// e.preventDefault();
		let input = document.getElementById('add_project_code');
		let data = {
			code: input.value
		};
		if(addingProject.level > 0) {
			let parentProject = altProjects[addingProject.alt][addingProject.level - 1];
			data.parentId = parentProject.id;
		}
		console.log('saveProject', data);
		saveProject(data).then(
			data => {
				console.log('saveProject response', data);
				if(data.status !== 200) {
					alert(data.message);
					return;
				}
				let clonedProjects = cloneAltProjects(altProjects);
				// add project to selection list and select it
				let project = clonedProjects[addingProject.alt][addingProject.level]
				project.selectionList.push(data.result);
				project.selectionList.sort((p1, p2) => {
					if(p1.code < p2.code) {
						return -1;
					}
					if(p1.code > p2.code) {
						return 1;
					}
					return 0;
				})
				project.id = data.result.id;
				setProjects(clonedProjects);
				setAddingProject(null);
			},
			error => {
				alert(error.message);
				console.error('error object', error);
			}
		);
	};

	// console.log('projects', projects);
	let altProjectRows = [];
	let altProjects = projects;
	for(let altProject of altProjects) {
		let levelProjects = altProject;
		// console.log('altProject', altProject);
		let projectRows = [];
		for(let levelProject of levelProjects) {
			console.log('levelProject', levelProject);
			let name = `project ${altProjectRows.length} ${projectRows.length}`;
			let key = `${altProjectRows.length}-${projectRows.length}`;
			console.log('addingProject', name, addingProject);
			if(addingProject != null && 
				altProjectRows.length === addingProject.alt && 
				projectRows.length === addingProject.level) {
					projectRows.push((
						<span key={key}>
						<input type="text" id="add_project_code" onChange={e => {
							let value = e.target.value;
							setAddProjectOkButtonDisabled(value === '');
						}}/>
						<button type="button" 
							onClick={handleAddProject}
							disabled={addProjectOkButtonDisabled}
							id="add_project_ok">OK</button>
						<button type="button" 
							onClick={e => {
								console.log('addProject cancel', e);
								setAddingProject(null);
							}}>Cancel</button>
						</span>
					))
					continue;
			}
			let projectIndex = projectRows.length;
			let altProjectIndex = altProjectRows.length;
			projectRows.push((
				<select value={levelProject.id || ''} 
					onChange={e => {
						const name = e.target.name;
						const value = e.target.value;
						if(value === 'add') {
							console.log('setAddingProject', name, altProjectIndex, projectIndex);
							setAddingProject({
								alt: altProjectIndex, 
								level: projectIndex
							});
						}
						else {
							handleEventProjectChange(name, value, projects).then(projects => {
								setProjects(projects)
							});
						}
					}} 
					name={name}
					key={key}>
					<option value="">?Select one...</option>
					<option value="add">+Add project...</option>
				{
					levelProject.selectionList.map(projectSelection => {
						return <option value={projectSelection.id} key={projectSelection.id}>
							{projectSelection.code}</option>
					})
				}	
				</select>
			));
		}
		console.log('projectRows', projectRows);
		altProjectRows.push(<div key={altProjectRows.length}>Alt {altProjectRows.length}: {projectRows}</div>);
	}

	let currentDate = new Date();
	return (
		<>
		<h1>{event == null ? 'Add Event' : `Edit Event ${event.id}`}</h1>
		<div>{formatDate(currentDate) + ' ' + formatTime(currentDate)}</div>
		<form onSubmit={handleSubmit}>
			<div>
				<div style={{float: 'left'}}>
					<div>
						<label>Date:</label>
					</div>
					<div>
						<DatePicker onChange={setDate} value={date}/>
					</div>
				</div>
				<div>
					<div>
						<label>Time:</label>
					</div>
					<div>
						<TimePicker onChange={setTime} value={time}/>
					</div>
				</div>
			</div>
			<div>
				<label>Projects:</label>
			</div>
			<div>
			{altProjectRows}
			</div>
			<div>
				<label>Comments:</label>
			</div>
			<div>
				<input type="text" name="comments" id="comments"
					value={comments || ""}
					onChange={handleCommentChange} />
			</div>
			<button type="submit">Submit</button>
			<button type="button" onClick={handleCancel}>Cancel</button>
		</form>
		</>
	);
};

export default EditEvent;